module.exports = __webpack_public_path__ + "img/pasta_rolled.7a6a2e07.jpg";